import React from "react";
import Navbar from "./Navbar.js";
import { useNavigate } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import Cookies from "universal-cookie";

// MUI Imports
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  ButtonBase,
  Container,
} from "@mui/material";
import { Globe, Cpu, ChevronRight } from "lucide-react";

const Settings = () => {
  const navigate = useNavigate();
  const cookies = new Cookies();

  const handleNavigation = (protocol) => {
    const userID = cookies.get("userID");
    if (protocol === "HTTP") {
      mixpanel.track("HTTP Source Page", { userID });
      navigate("/http_sources", { replace: true });
    } else if (protocol === "MQTT") {
      mixpanel.track("MQTT Source Page", { userID });
      navigate("/mqtt_sources", { replace: true });
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#0f1729", color: "white" }}>
      <Navbar />

      <Container maxWidth="md" sx={{ py: { xs: 4, md: 8 } }}>
        {/* Header Section */}
        <Box sx={{ mb: 6, textAlign: "left" }}>
          <Typography
            variant="h4"
            sx={{ fontWeight: 700, mb: 1, letterSpacing: "-0.02em" }}
          >
            Dashboard Settings
          </Typography>
          <Typography variant="body1" sx={{ color: "rgba(255,255,255,0.6)" }}>
            Select a protocol to manage your data sources and integrations.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {/* HTTP Option */}
          <Grid item xs={12} sm={6}>
            <ButtonBase
              onClick={() => handleNavigation("HTTP")}
              sx={{ width: "100%", textAlign: "left", borderRadius: "16px" }}
            >
              <Card
                sx={{
                  width: "100%",
                  bgcolor: "#1e293b",
                  color: "white",
                  borderRadius: "16px",
                  border: "1px solid #334155",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    borderColor: "#3b82f6",
                    bgcolor: "rgba(59, 130, 246, 0.05)",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <CardContent
                  sx={{ p: 4, display: "flex", alignItems: "center", gap: 3 }}
                >
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "rgba(59, 130, 246, 0.1)",
                      color: "#3b82f6",
                      borderRadius: "12px",
                    }}
                  >
                    <Globe size={32} />
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" fontWeight={600}>
                      HTTP Protocol
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(255,255,255,0.5)" }}
                    >
                      REST APIs & Webhook logging
                    </Typography>
                  </Box>
                  <ChevronRight size={20} color="rgba(255,255,255,0.3)" />
                </CardContent>
              </Card>
            </ButtonBase>
          </Grid>

          {/* MQTT Option */}
          <Grid item xs={12} sm={6}>
            <ButtonBase
              onClick={() => handleNavigation("MQTT")}
              sx={{ width: "100%", textAlign: "left", borderRadius: "16px" }}
            >
              <Card
                sx={{
                  width: "100%",
                  bgcolor: "#1e293b",
                  color: "white",
                  borderRadius: "16px",
                  border: "1px solid #334155",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    borderColor: "#4ade80",
                    bgcolor: "rgba(74, 222, 128, 0.05)",
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <CardContent
                  sx={{ p: 4, display: "flex", alignItems: "center", gap: 3 }}
                >
                  <Box
                    sx={{
                      p: 2,
                      bgcolor: "rgba(74, 222, 128, 0.1)",
                      color: "#4ade80",
                      borderRadius: "12px",
                    }}
                  >
                    <Cpu size={32} />
                  </Box>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" fontWeight={600}>
                      MQTT Protocol
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(255,255,255,0.5)" }}
                    >
                      IoT Devices & Broker logging
                    </Typography>
                  </Box>
                  <ChevronRight size={20} color="rgba(255,255,255,0.3)" />
                </CardContent>
              </Card>
            </ButtonBase>
          </Grid>
        </Grid>

        {/* Footer Text style note */}
        <Box sx={{ mt: 6, p: 3, borderTop: "1px solid #1e293b" }}>
          <Typography
            variant="body2"
            sx={{ color: "rgba(255,255,255,0.4)", textAlign: "center" }}
          >
            Need help? Consult the documentation for protocol specifications.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Settings;
